module.exports = __webpack_public_path__ + "img/power_point.97d75896.jpeg";